import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getWheelsRadiusParts } from '../thunks/partsThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearPartsKey } from '../thunkKeys/partsThunksKeys';

const SLICE_NAME = 'wheelsRadiusParts';

export const wheelsRadiusPartsSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearWheelsRadiusParts(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getWheelsRadiusParts });
        builder.addCase(clearPartsKey, () => commonInitialState);
    },
});

export const { clearWheelsRadiusParts } = wheelsRadiusPartsSlice.actions;

export const wheelsRadiusParts = wheelsRadiusPartsSlice.reducer;
